import React from 'react';
interface Props {
  title: string;
}

function CollectionTitle({ title }: Props) {
  return (
    <div
      css={{
        fontSize: '18px',
        fontWeight: 'bold',
        lineHeight: '24px',
        color: 'rgba(12, 12, 12, 1)',
        marginBottom: '16px',
      }}
    >
      {title}
    </div>
  );
}

export default CollectionTitle;
